/**
 * Rating pill for the 7-state evidence taxonomy.
 *
 * Pulls colors from `--rt-{verdict}` tokens so brand revisions to
 * `colors_and_type.css` re-skin every pill automatically.
 */

import type { VerdictCode } from '@eloquor/api-contract';

const labels: Record<VerdictCode, string> = {
  ok: 'ok',
  ethicsvio: 'ethics-vio',
  miscut: 'miscut',
  powertagged: 'powertagged',
  unclear: 'unclear',
  error: 'error',
  unchecked: 'unchecked',
};

export interface RatingPillProps {
  verdict: VerdictCode;
  size?: 'sm' | 'md';
}

export function RatingPill({ verdict, size = 'md' }: RatingPillProps) {
  const sm = size === 'sm';
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: sm ? '2px 8px' : '3px 10px',
        background: `var(--rt-${verdict}-soft)`,
        color: `var(--rt-${verdict}-ink)`,
        border: `1px ${verdict === 'unchecked' ? 'dashed' : 'solid'} var(--rt-${verdict})`,
        borderRadius: 2,
        fontFamily: 'var(--font-mono)',
        fontSize: sm ? 10.5 : 11.5,
        fontWeight: 600,
        letterSpacing: '0.02em',
        lineHeight: 1,
      }}
    >
      <span
        aria-hidden
        style={{
          width: 6,
          height: 6,
          borderRadius: 999,
          background: `var(--rt-${verdict})`,
        }}
      />
      {labels[verdict]}
    </span>
  );
}
